export const FETCH_FEATURE_FLAGS_DATA = "FETCH_FEATURE_FLAGS_DATA";
export const FETCH_FEATURE_FLAGS_DATA_SUCCESS = "FETCH_FEATURE_FLAGS_DATA_SUCCESS";
export const FETCH_FEATURE_FLAGS_DATA_FAILURE = "FETCH_FEATURE_FLAGS_DATA_FAILURE";